import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'

/**
 * FEV O REMISIÓN (0296): en qué se vuelve cada cotización de la orden al
 * pasar por bodega, y si todavía se puede cambiar (no, si bodega ya la pasó).
 * 0299: sin IVA va a remisión y no se le puede escoger FEV.
 */
export type DocumentoAlAlistar = {
  id: string
  /** El que le toca de verdad: remisión si no lleva IVA. */
  documento: 'fev' | 'remision'
  /** Bodega ya la pasó a su documento: la decisión quedó tomada. */
  pasada: boolean
  /** No lleva IVA: World Office no la factura, va a remisión. */
  sin_iva: boolean
  /** Solo servicios (0301): no va a bodega. */
  solo_servicios: boolean
  aprobada: boolean
}

export function useDocumentosAlAlistar(ordenServicioId: string) {
  return useQuery({
    queryKey: ['documento-al-alistar', ordenServicioId],
    queryFn: async (): Promise<Record<string, DocumentoAlAlistar>> => {
      const { data, error } = await supabase.rpc('fn_documentos_al_alistar', {
        p_orden_servicio_id: ordenServicioId,
      })
      if (error) throw new Error(mensajeDeError(error))
      return Object.fromEntries(
        ((data ?? []) as DocumentoAlAlistar[]).map((f) => [f.id, f]),
      )
    },
  })
}

/** Cambiar la decisión mientras bodega no la haya pasado. */
export function useCambiarDocumentoAlAlistar(ordenServicioId: string) {
  const cliente = useQueryClient()

  return useMutation({
    mutationFn: async ({
      cotizacionId,
      documento,
    }: {
      cotizacionId: string
      documento: 'fev' | 'remision'
    }) => {
      const { error } = await supabase.rpc('fn_cambiar_documento_de_cotizacion', {
        p_cotizacion_id: cotizacionId,
        p_documento: documento,
      })
      if (error) throw new Error(mensajeDeError(error))
    },
    onSuccess: async () => {
      await cliente.invalidateQueries({ queryKey: ['documento-al-alistar', ordenServicioId] })
      await cliente.invalidateQueries({ queryKey: ['alistamientos'] })
    },
  })
}
